type ServiceOption = {
  name: string
  price: number
  selected?: boolean
}

export type ServiceOptions = {
  mot: ServiceOption
  oilAndFilter: ServiceOption
  standardService: ServiceOption
  majorService: ServiceOption
  standardServiceEV: ServiceOption
  majorServiceEV: ServiceOption
}

export const serviceOptionDefaults: ServiceOptions = {
  mot: {
    name: 'MOT',
    price: 39.95,
  },
  oilAndFilter: {
    name: 'Oil & filter',
    price: 129.95,
  },
  standardService: {
    name: 'Standard service',
    price: 159.95,
  },
  majorService: {
    name: 'Major service',
    price: 214.95,
  },
  standardServiceEV: {
    name: 'Standard electric vehicle (EV) service',
    price: 159.95,
  },
  majorServiceEV: {
    name: 'Major electric vehicle (EV) service',
    price: 214.95,
  },
}

export enum ContactTimePreference {
  AM = 'AM',
  PM = 'PM',
}

export enum VehicleType {
  EV = 'Ev',
  COMBUSTIBLE = 'Combustible',
}

export type AppointmentType = 'Drop and go' | 'Drop and wait'

export type BookingRequest = {
  customer: Customer
  vehicle: Vehicle
  bookingDetails: BookingDetails
  campaignId?: string
}

type Vehicle = {
  vin: string
  vrm: string
  mileage: number
}

type BookingDetails = {
  storeId: string
  bookingDate: string
  bookingTime: string
  appointmentTypeId: number
  serviceOptions: BookingDetailsServiceOptions[]
}

type BookingDetailsServiceOptions = {
  serviceType: string
  description: string
}

type Customer = {
  title: string
  firstName: string
  lastName: string
  mobile: string
  email: string
  address: Address
}

type Address = {
  street: string
  city?: string
  county?: string
  postCode: string
}

export type CustomerAddress = {
  addressLine1: string
  addressLine2?: string
  postTown: string
  county: string
  postcode: string
}
